// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./client-recommendations-env.d.ts" />

export { initRecommendations } from "./initialize";
export { RECOMMENDATIONS_SCRIPT_URL } from "./scriptURL";
export { getRecommendations, sendRecommendationsPageData } from "./communicate";
export { setBasketPage, setCategoryPage, setDepartmentPage, setHomepage, setOrderConfirmationPage, setPartnerProductsPage, setProductDetailPage, setSearchResultsPage, setGenericPage } from "./page";
export { setBasketItem, setCategoryProductCodes, setOrderNumber, setProductAddedToBasket, setProductContextCategory, setPurchasedItem, setSearchResultsProductCodes } from "./content";